import styled from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const StyledCard = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 8px;
    padding: 33px 33px 66px;
    background-color: ${colors.light};
    flex: 1;
    
    .content-header {
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      
      img.icon {
        max-width: 40px;
        display: inline-block;
        vertical-align: middle;
        margin-top: 5px;
      }
    }

    h4 {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-weight: medium;
        font-size: 23px;
        letter-spacing: 0;
        color: ${colors.softDark};        
        vertical-align: middle;
        margin-bottom: 0;
        display: inline-block;
        line-height: 21px;
      }

      span {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-weight: medium;
        font-size: 23px;
        letter-spacing: 0;
        color: ${colors.lightRed};        
        vertical-align: middle;
        margin-bottom: 0;
        display: inline-block;
        margin-top: 10px;
        line-height: 21px;
      }
    
    .content-body {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color: ${colors.grey};
        font-size: 17px;
        text-align: left;
        margin-top: 15px;
    }

    @media screen and (max-width: 1919px) {
    padding: 33px 33px 33px;
    
    .content-header {
      margin-bottom: 15px;
      
      img.icon {
        max-width: 30px;
        display: inline-block;
        vertical-align: middle;
        margin-top: 5px;
      }

    }

    h4 {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-weight: medium;
        font-size: 16px;
        letter-spacing: 0;
        color: ${colors.softDark};        
        vertical-align: middle;
        margin-bottom: 0;
        display: inline-block;
      }

      span {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-weight: medium;
        font-size: 16px;
        letter-spacing: 0;
        color: ${colors.lightRed};        
        vertical-align: middle;
        margin-bottom: 0;
        display: inline-block;
        margin-top: 5px;
        line-height: 1;
      }
      .content-body {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color: ${colors.grey};
        font-size: 14px;
        text-align: left;
        margin-top: 15px;
    }
  }  
  
  @media screen and (max-width: ${ScreenSize.tablet}px) {
    padding: 18px 10px 33px;
    h4 {
        font-size: 16px;
    }
    span {
        font-size: 16px;
        line-height: 15px;
        margin-top: 0;
    }
    .content-body {
        max-height: 120px;
        font-size: 12px;
        text-align: left;
        margin-top: 15px;
        margin-bottom: 50px;
    }
}

@media screen and (max-width: ${ScreenSize.portrait}px) {
    .content-header {
      
      img.icon {
        margin-top: 0;
      }

    }
    .content-body {
        margin-bottom: 0;
    }
}
`;
